export const PROFILE_PHOTO_MAX_SIZE = 4 * 1024 * 1024;
export const COMPANY_LOGO_MAX_SIZE = 5 * 1024 * 1024;
export const COMPANY_PROFILE_ENDPOINT = process.env.REACT_APP_COMPANY_PROFILE_API_URL || "/host/company-profile";
export const PROFILE_UPLOAD_URL_ENDPOINT = process.env.REACT_APP_PROFILE_UPLOAD_URL_ENDPOINT || "https://chwuyn0b23.execute-api.eu-north-1.amazonaws.com/default";
export const UPDATE_EMAIL_ENDPOINT = process.env.REACT_APP_UPDATE_EMAIL_ENDPOINT || "https://ms26uksm37.execute-api.eu-north-1.amazonaws.com/dev/General-CustomerIAM-Production-Update-UserEmail";
export const UPDATE_NAME_ENDPOINT = process.env.REACT_APP_UPDATE_NAME_ENDPOINT || "https://5imk8jy3hf.execute-api.eu-north-1.amazonaws.com/default/General-CustomerIAM-Production-Update-UserName";
export const UPDATE_PHONE_ENDPOINT = process.env.REACT_APP_UPDATE_PHONE_ENDPOINT || "https://24oly7cicg.execute-api.eu-north-1.amazonaws.com/default/General-CustomerIAM-Production-Update-PhoneNumber";

export const languageOptions = [
    {value: "en", label: "English"},
    {value: "nl", label: "Nederlands"},
    {value: "de", label: "Deutsch"},
    {value: "es", label: "Español"},
];

export const dateFormatOptions = [
    {value: "en", label: "English (MM/DD/YYYY)"},
    {value: "nl", label: "Dutch (DD-MM-YYYY)"},
];

export const priceFormatOptions = [
    {value: "usd", label: "Dollar ($)"},
    {value: "eur", label: "Euro (€)"},
    {value: "other", label: "Other"},
];

export const countryCodes = [
    {code: "+1", name: "United States/Canada"},
    {code: "+7", name: "Russia"},
    {code: "+20", name: "Egypt"},
    {code: "+27", name: "South Africa"},
    {code: "+30", name: "Greece"},
    {code: "+31", name: "Netherlands"},
    {code: "+32", name: "Belgium"},
    {code: "+33", name: "France"},
    {code: "+34", name: "Spain"},
    {code: "+36", name: "Hungary"},
    {code: "+39", name: "Italy"},
    {code: "+40", name: "Romania"},
    {code: "+44", name: "United Kingdom"},
    {code: "+45", name: "Denmark"},
    {code: "+46", name: "Sweden"},
    {code: "+47", name: "Norway"},
    {code: "+48", name: "Poland"},
    {code: "+49", name: "Germany"},
    {code: "+52", name: "Mexico"},
    {code: "+54", name: "Argentina"},
    {code: "+55", name: "Brazil"},
    {code: "+56", name: "Chile"},
    {code: "+57", name: "Colombia"},
    {code: "+58", name: "Venezuela"},
    {code: "+60", name: "Malaysia"},
    {code: "+61", name: "Australia"},
    {code: "+62", name: "Indonesia"},
    {code: "+63", name: "Philippines"},
    {code: "+64", name: "New Zealand"},
    {code: "+65", name: "Singapore"},
    {code: "+66", name: "Thailand"},
    {code: "+81", name: "Japan"},
    {code: "+82", name: "South Korea"},
    {code: "+84", name: "Vietnam"},
    {code: "+86", name: "China"},
    {code: "+90", name: "Turkey"},
    {code: "+91", name: "India"},
    {code: "+92", name: "Pakistan"},
    {code: "+93", name: "Afghanistan"},
    {code: "+94", name: "Sri Lanka"},
    {code: "+95", name: "Myanmar"},
    {code: "+98", name: "Iran"},
    {code: "+212", name: "Morocco"},
    {code: "+213", name: "Algeria"},
    {code: "+216", name: "Tunisia"},
    {code: "+218", name: "Libya"},
    {code: "+220", name: "Gambia"},
    {code: "+221", name: "Senegal"},
    {code: "+223", name: "Mali"},
    {code: "+225", name: "Ivory Coast"},
    {code: "+230", name: "Mauritius"},
    {code: "+234", name: "Nigeria"},
    {code: "+254", name: "Kenya"},
    {code: "+255", name: "Tanzania"},
    {code: "+256", name: "Uganda"},
    {code: "+260", name: "Zambia"},
    {code: "+263", name: "Zimbabwe"},
    {code: "+267", name: "Botswana"},
    {code: "+356", name: "Malta"},
    {code: "+358", name: "Finland"},
    {code: "+359", name: "Bulgaria"},
    {code: "+370", name: "Lithuania"},
    {code: "+371", name: "Latvia"},
    {code: "+372", name: "Estonia"},
    {code: "+373", name: "Moldova"},
    {code: "+374", name: "Armenia"},
    {code: "+375", name: "Belarus"},
    {code: "+376", name: "Andorra"},
    {code: "+380", name: "Ukraine"},
    {code: "+381", name: "Serbia"},
    {code: "+385", name: "Croatia"},
    {code: "+386", name: "Slovenia"},
    {code: "+387", name: "Bosnia and Herzegovina"},
    {code: "+389", name: "North Macedonia"},
    {code: "+420", name: "Czech Republic"},
    {code: "+421", name: "Slovakia"},
    {code: "+423", name: "Liechtenstein"},
    {code: "+500", name: "Falkland Islands"},
    {code: "+501", name: "Belize"},
    {code: "+502", name: "Guatemala"},
    {code: "+503", name: "El Salvador"},
    {code: "+504", name: "Honduras"},
    {code: "+505", name: "Nicaragua"},
    {code: "+506", name: "Costa Rica"},
    {code: "+507", name: "Panama"},
    {code: "+509", name: "Haiti"},
    {code: "+852", name: "Hong Kong"},
    {code: "+853", name: "Macau"},
    {code: "+855", name: "Cambodia"},
    {code: "+856", name: "Laos"},
    {code: "+880", name: "Bangladesh"},
    {code: "+960", name: "Maldives"},
    {code: "+961", name: "Lebanon"},
    {code: "+962", name: "Jordan"},
    {code: "+963", name: "Syria"},
    {code: "+964", name: "Iraq"},
    {code: "+965", name: "Kuwait"},
    {code: "+966", name: "Saudi Arabia"},
    {code: "+967", name: "Yemen"},
    {code: "+971", name: "United Arab Emirates"},
    {code: "+972", name: "Israel"},
    {code: "+973", name: "Bahrain"},
    {code: "+974", name: "Qatar"},
    {code: "+975", name: "Bhutan"},
    {code: "+976", name: "Mongolia"},
    {code: "+977", name: "Nepal"},
    {code: "+992", name: "Tajikistan"},
    {code: "+993", name: "Turkmenistan"},
    {code: "+994", name: "Azerbaijan"},
    {code: "+995", name: "Georgia"},
    {code: "+996", name: "Kyrgyzstan"},
    {code: "+998", name: "Uzbekistan"},
];

export const titleOptions = ["", "Dr.", "Mr.", "Mrs.", "Ms.", "Prof."];
export const sexOptions = ["", "Female", "Male", "Other", "Prefer not to say"];
